import MuiAlert from 'theme/overrides/MuiAlert';
import MuiIconButton from 'theme/overrides/MuiIconButton';
import MuiInputAdornment from 'theme/overrides/MuiInputAdornment';
import MuiPaper from 'theme/overrides/MuiPaper';
import MuiTab from 'theme/overrides/MuiTab';
import MuiTabs from 'theme/overrides/MuiTabs';
import MuiTableCell from 'theme/overrides/MuiTableCell';
import MuiTableHead from 'theme/overrides/MuiTableHead';
import MuiTypography from 'theme/overrides/MuiTypography';
import MuiInputBase from 'theme/overrides/MuiInputBase';
import MuiListItem from 'theme/overrides/MuiListItem';
import MuiCssBaseline from 'theme/overrides/MuiCssBaseline';
import MuiFilledInput from 'theme/overrides/MuiFilledInput';
import MuiTableRow from 'theme/overrides/MuiTableRow';
import MuiTableSortLabel from 'theme/overrides/MuiTableSortLabel';
import MuiAutocomplete from 'theme/overrides/MuiAutocomplete';
import MuiDropzoneArea from 'theme/overrides/MuiDropzoneArea';
import MuiCardHeader from 'theme/overrides/MuiCardHeader';
import MuiSlider from 'theme/overrides/MuiSlider';
import MuiDialogContent from 'theme/overrides/MuiDialogContent';
import MuiFormLabel from 'theme/overrides/MuiFormLabel';
import MuiFormHelperText from 'theme/overrides/MuiFormHelperText';
import MuiInput from 'theme/overrides/MuiInput';
import MuiRadio from 'theme/overrides/MuiRadio';
import MuiCheckbox from 'theme/overrides/MuiCheckbox';
import MuiCardContent from 'theme/overrides/MuiCardContent';
import MuiOutlinedInput from 'theme/overrides/MuiOutlinedInput';
import MuiAppBar from 'theme/overrides/MuiAppBar';
import MuiDataGrid from 'theme/overrides/MuiDataGrid';
import MuiFormControl from 'theme/overrides/MuiFormControl';
import MuiDialogActions from 'theme/overrides/MuiDialogActions';

const overrides = {
  spacing: '55%',
  padding: '3%',
  MuiAlert,
  MuiCardContent,
  MuiCardHeader,
  MuiCheckbox,
  MuiCssBaseline,
  MuiDataGrid,
  MuiDropzoneArea,
  MuiFilledInput,
  MuiFormControl,
  MuiIconButton,
  MuiAutocomplete,
  MuiTableSortLabel,
  MuiInput,
  MuiInputBase,
  MuiInputAdornment,
  MuiOutlinedInput,
  MuiPaper,
  MuiRadio,
  MuiTab,
  MuiTabs,
  MuiTableCell,
  MuiTableHead,
  MuiTableRow,
  MuiTypography,
  MuiListItem,
  MuiSlider,
  MuiDialogContent,
  MuiDialogActions,
  MuiFormLabel,
  MuiFormHelperText,
  MuiAppBar,
};

export default overrides;
